import { useState, useCallback, useEffect } from "react";
import tourIcon from "../logos/tour.png";
import MapButton from "../Map/MapButton";
import TourDropdown from "./TourDropdown";
import TourModal from "./TourModal";

// Component to handle the map tour button, dropdown list, and modal

function TourControl({ tours, onSelect, showList, onToggleList, setIsMarkerSelected, setIsTourModalOpen }) {
  const [selectedTour, setSelectedTour] = useState(null);
  const [dropdownPos, setDropdownPos] = useState({ top: 72, left: 12 });

  // Calculate and update dropdown position relative to the tour button on the map (this is done to ensure
  // that the dropdown will always sit right on top of the tour button even if preceding buttons are
  // invisible, e.g. because the were disabled)
  const updateDropdownPos = useCallback(() => {
    const btn = document.querySelector('.map-button-tour .map-button');
    if (!btn) return;

    const rect = btn.getBoundingClientRect();
    const top = rect.top;
    const left = rect.left;

    setDropdownPos({ top, left });
  }, []);

  // Keep dropdown aligned when visible, listening to resize/scroll events
  useEffect(() => {
    if (!showList) return;  // Only attach listeners if dropdown is shown

    updateDropdownPos();

    // Update position on window resize or scroll
    window.addEventListener('resize', updateDropdownPos);
    window.addEventListener('scroll', updateDropdownPos, true);

    // Cleanup: remove event listeners when dropdown hides or component unmounts
    return () => {
      window.removeEventListener('resize', updateDropdownPos);
      window.removeEventListener('scroll', updateDropdownPos, true);
    };
  }, [showList, updateDropdownPos]);

  // Toggle dropdown visibility
  const handleButtonClick = () => {
    onToggleList(!showList);
  };

  // Close dropdown
  const handleDropdownClose = () => {
    onToggleList(false);
  };

  // Handle selecting a tour from the dropdown
  const handleSelectTour = (tour) => {
    setSelectedTour(tour);
    setIsMarkerSelected(false);
    setIsTourModalOpen(true);
  };

  return (
    <div>

      {/* Map button for opening the tour dropdown */}
      {tours.length > 0 && (
        <MapButton
          icon={tourIcon}
          title="Touren"
          controlClass="map-button-tour"
          onClick={handleButtonClick}
        />
      )}

      {/* Dropdown list of tours */}
      {showList && (
        <TourDropdown
          tours={tours}
          onSelect={handleSelectTour}
          onClose={handleDropdownClose}
          style={{
            position: 'fixed',
            top: `${dropdownPos.top}px`,
            left: `${dropdownPos.left}px`,
            zIndex: 2500
          }}
        />
      )}

      {/* Modal for the currently selected tour */}
      <TourModal
        tour={selectedTour}
        onStart={onSelect}
        onClose={() => {
          setSelectedTour(null);
          setIsTourModalOpen(false);
        }}
      />
    </div>
  );
}

export default TourControl;